import { authenticated } from '../../helpers/auth-header';
import insighttAPI from '../clients/insightt-api-client';
import { authEndpoints } from '../endpoints';

const loginByEmail = (payload) => {
  delete insighttAPI.headers.Authorization;
  return insighttAPI.post(authEndpoints.loginByEmailAPI(), payload);
};

const crossLogin = (payload) => {
  delete insighttAPI.headers.Authorization;
  return insighttAPI.post(authEndpoints.crossLoginAPI(), payload);
};

const registerDeviceToken = (payload) =>
  authenticated(insighttAPI).post(authEndpoints.registerDeviceTokenAPI(), payload);

/**
 * Stops push notifications to this browser. The sign-out owner calls this before local clearing,
 * with the token it captured, as it does for `logout`.
 */
const unregisterDeviceToken = (payload, accessToken) =>
  insighttAPI.delete(
    authEndpoints.registerDeviceTokenAPI(),
    {},
    { data: payload, headers: { Authorization: `Bearer ${accessToken}` } },
  );

const forgotPassword = (payload) => {
  delete insighttAPI.headers.Authorization;
  return insighttAPI.post(authEndpoints.forgotPasswordAPI(), payload);
};

const resetPassword = (payload) => {
  delete insighttAPI.headers.Authorization;
  return insighttAPI.post(authEndpoints.resetPasswordAPI(), payload);
};
const acceptInvite = (payload) => {
  delete insighttAPI.headers.Authorization;
  return insighttAPI.post(authEndpoints.acceptInviteAPI(), payload);
};

const setPassword = (payload) => {
  delete insighttAPI.headers.Authorization;
  return insighttAPI.post(authEndpoints.setPasswordAPI(), payload);
};

const updatePassword = (payload) => authenticated(insighttAPI).put(authEndpoints.updatePasswordAPI(), payload);

/**
 * Ends the legacy server session. The sign-out owner calls this after local clearing, so the token
 * captured before clearing is sent explicitly rather than read from the (now empty) boundary.
 */
const logout = (payload, accessToken) =>
  insighttAPI.post(authEndpoints.logoutAPI(), payload, { headers: { Authorization: `Bearer ${accessToken}` } });

export const authService = {
  loginByEmail,
  crossLogin,
  registerDeviceToken,
  unregisterDeviceToken,
  forgotPassword,
  resetPassword,
  acceptInvite,
  setPassword,
  updatePassword,
  logout,
};
